import React from "react";
import Nav from "../Nav/NavBar";
import BackgroundVideo from "../../assets/video/backgorund.mp4";

const SectionA = ({ id, title, body, btn }) => {
  return (
    <div id="tab_1" className="about__container">
      <div className="overlay"></div>
      <video autoPlay loop muted>
        <source src={BackgroundVideo} type="video/mp4" />
      </video>

      <div className="horiContainer containerPro">
        {/* <Nav /> */}
        <div className="innerCon">
          <div>
            <h1 className="heading1">{title}</h1>
            <p className="para">{body}</p>
            {btn && (
              <div className="about__buttons">
                <button
                  onClick={() =>
                    document
                      .querySelector("#tab_5")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                  className="btn btn-primary"
                >
                  Let's Talk
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SectionA;
